import { useQuery } from '@tanstack/react-query';
import {
  userActivityApi,
  resolveTimeZone,
  type ActivityInterval,
  type ActivityScope,
} from '@/lib/api/user-activity';
import { useAuthStore } from '@/stores/auth-store';

export const userActivityKeys = {
  all: ['user-activity'] as const,
  list: (
    interval: ActivityInterval,
    page: number,
    limit: number,
    timeZone: string,
    scope?: ActivityScope,
    scopeId?: string
  ) =>
    [...userActivityKeys.all, interval, page, limit, timeZone, scope, scopeId] as const,
};

export function useUserActivity(
  interval: ActivityInterval = 'week',
  page: number = 1,
  limit: number = 30,
  scope?: ActivityScope,
  scopeId?: string
) {
  const userTimeZone = useAuthStore((s) => s.user?.timeZone);
  const timeZone = resolveTimeZone(userTimeZone);

  return useQuery({
    queryKey: userActivityKeys.list(interval, page, limit, timeZone, scope, scopeId),
    queryFn: () => {
      const params: { interval: ActivityInterval; page: number; limit: number; timeZone: string; scope?: ActivityScope; scopeId?: string } = {
        interval,
        page,
        limit,
        timeZone,
      };
      if (scope !== undefined) params.scope = scope;
      if (scopeId !== undefined) params.scopeId = scopeId;
      return userActivityApi.get(params);
    },
    enabled: !((scope === 'team' || scope === 'user') && !scopeId),
    staleTime: 30_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}
